import { Routes, Route } from "react-router-dom";
import { supervisornavigationLinks } from "../data/navData";
import DashboardLayout from "../layout/DashboardLayout/DashboardLayout";
import SupervisorHome from "../pages/SupervisorPage/SupervisorHome";
import SupervisorWO from "../pages/SupervisorPage/SupervisorWO";
import Account from "../components/Account/Account";
import ProtectedRoute from "./ProtectedRoute";
import SupervisorMReport from "../pages/SupervisorPage/SupervisorMReport";
import SupervisorRReport from "../pages/SupervisorPage/SupervisorRReport";
import FeedbackReport from "../pages/FeedbackReport2";
// import VendorManagement from "../pages/managerPage/VendorManagement";
import Calendar from "../components/Calendar/Calendar";
import CalendarOverview from "../components/Calendar/CalendarOverview";
import SupervisorAttendance from "../pages/SupervisorPage/SupervisorAttendance";
import SupervisorAttendanceRecords from "../pages/SupervisorPage/SupervisorAttendanceRecords";
import SupervisorLeaveRecords from "../pages/SupervisorPage/SupervisorLeaveRecords";
import SupervisorApplyLeave from "../pages/SupervisorPage/SupervisorApplyLeave";
import SupervisorEmployeeLeaveRequests from "../pages/SupervisorPage/SupervisorEmployeeLeaveRequests";
import SupervisorEmployeeAttendance from "../pages/SupervisorPage/SupervisorEmployeeAttendance";
import AttendanceRecordDetail from "../pages/attendance/AttendanceRecordDetail";
import OvertimeDashboard from "../pages/SupervisorPage/OvertimeDashboard";
import SupervisorOvertimeRequests from "../pages/SupervisorPage/SupervisorOvertimeRequests";

const SupervisorRoutes = () => {
  return (
    <DashboardLayout
      navigationLinks={supervisornavigationLinks}
      roleBasePath="supervisor"
      useApiLogout={false}
    >
      <Routes>
        <Route
          path=""
          element={
            <ProtectedRoute
              element={<SupervisorHome />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="attendance/record/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="work-order"
          element={
            <ProtectedRoute
              element={<SupervisorWO />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="repair-report"
          element={
            <ProtectedRoute
              element={<SupervisorRReport />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="maintenance-report"
          element={
            <ProtectedRoute
              element={<SupervisorMReport />}
              requiredRole="Supervisor"
            />
          }
        />
        {/* <Route
          path="vendor"
          element={
            <ProtectedRoute
              element={<VendorManagement />}
              requiredRole="Supervisor"
            />
          }
        /> */}
        <Route
          path="account"
          element={
            <ProtectedRoute element={<Account />} requiredRole="Supervisor" />
          }
        />
        <Route
          path="feedback"
          element={
            <ProtectedRoute
              element={<FeedbackReport />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="calendar"
          element={
            <ProtectedRoute
              element={<CalendarOverview />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="calendar/:year"
          element={
            <ProtectedRoute element={<Calendar />} requiredRole="Supervisor" />
          }
        />
        <Route
          path="attendance"
          element={
            <ProtectedRoute
              element={<SupervisorAttendance />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="attendance/record"
          element={
            <ProtectedRoute
              element={<SupervisorAttendanceRecords />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="attendance/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="attendance/leave-records"
          element={
            <ProtectedRoute
              element={<SupervisorLeaveRecords />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="attendance/apply-leave"
          element={
            <ProtectedRoute
              element={<SupervisorApplyLeave />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="attendance/employee-leave-requests"
          element={
            <ProtectedRoute
              element={<SupervisorEmployeeLeaveRequests />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="attendance/employee-attendance"
          element={
            <ProtectedRoute
              element={<SupervisorEmployeeAttendance />}
              requiredRole="Supervisor"
            />
          }
        />
        <Route
          path="overtime"
          element={
            <ProtectedRoute element={<OvertimeDashboard />} requiredRole="Supervisor" />
          }
        />
          <Route
            path="overtime/requests"
            element={
              <ProtectedRoute element={<SupervisorOvertimeRequests />} requiredRole="Supervisor" />
            }
          />
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      </Routes>
    </DashboardLayout>
  );
};

export default SupervisorRoutes;
